export default __webpack_public_path__ + "static/media/dog1portrait.60c8694b.jpg";